import React from 'react';
import { Box, useTheme } from '@mui/material';
import { useAtomValue } from 'jotai';
import { ParentSize } from '@visx/responsive';
import BarChart from '../../../Components/Charts/BarChart';
import GraphsLegend from '../../../Components/Charts/GraphsLegend';
import { themeAtom } from '../../../Atoms';
import BranchCountersTooltip from './BranchCountersTooltip';

const AppointmentsBranchCounters = function AppointmentsBranchCounters({
  branchCounters,
}) {
  const theme = useTheme();
  const currentTheme = useAtomValue(themeAtom);
  const branches = branchCounters?.map(({ name }) => name);

  const completedAppointmentsData = branchCounters?.map((d, index) => ({
    index: index + 1,
    label: d?.name,
    [d?.name]: d?.count,
    details: d?.details,
  }));
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          paddingBottom: "16px"
        }}>
        <GraphsLegend
          flexDirection="row"
          legendData={branches}
          legendColor={theme.custom
            .generateConsistentUniqueColors(branches)
            ?.map((x) => x[currentTheme])}
        />
      </Box>
      <Box
        sx={{
          width: "auto",
          height: "40vh"
        }}>
        <ParentSize>
          {(parent) => (
            //parent component passes his css properties to BarChart
            (<BarChart
              width={parent.width}
              height={parent.height}
              dataToShow={completedAppointmentsData}
              keys={branches}
              colors={theme.custom
                .generateConsistentUniqueColors(branches)
                ?.map((x) => x[currentTheme])}
              TooltipContent={BranchCountersTooltip}
            />)
          )}
        </ParentSize>
      </Box>
    </>
  );
};

export default AppointmentsBranchCounters;
